import React from 'react';

import LottieView from 'lottie-react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';

export const DesktopAnimation: React.FC = () => {
  const uri = useStaticLottieUri(StaticImages.BurgerBounceLoader);

  if (!uri) {
    return null;
  }

  return (
    <LottieView
      source={{ uri }}
      autoPlay
      loop
      style={{
        alignSelf: 'center',
        width: '50%',
      }}
      resizeMode="cover"
    />
  );
};
